export default __webpack_public_path__ + "static/media/rare2.7ff673d1.png";